import "./SeriesSelector.scss";
import React from "react";
import { useSelector } from "react-redux";
import { selectText } from "../../../translation/translationSlice";
import { series } from "../../../../data"

function SeriesSelector({ children }) {
  const t = useSelector(selectText);

  return (
    <div className="SeriesSelector">
      <div className="SeriesSelector-label">{t("ui-series")}</div>
      <div className="SeriesSelector-name">{t(series)}</div>
      <div className="SeriesSelector-power">{t(`${series}-hp`)}</div>
    </div>
  );
}

export default SeriesSelector;
